import {fetch} from "utils/dataAccess";

export default async function deleteNotification(item) {
    const response = await fetch(item["@id"], {
        method: "DELETE",
    });

    if (!response.ok) throw new Error('Failed to delete notification');

    return response;
}
